export enum MetasTransactionEnum {
    AGENT = 'agent',
    VIA = 'via',
    LANG = 'lang',
    REFERRER = 'referrer',
    UTM_SOURCE = 'utm_source',
    UTM_CAMPAIGN = 'utm_campaign',
    UTM_MEDIUM = 'utm_medium',
    UTM_CONTENT = 'utm_content',
    UTM_TERM = 'utm_term',
    GOOGLE_GCLID = 'google_gclid',
    FACEBOOK_FBCLID = 'facebook_fbclid',
    PUBLIC_OBSERVATION = 'public_observation'
}

export enum ViaTransactinoEnum {
    LANDING = 'landing',
    DASHBOARD = 'dashboard',
    MOBILE = 'mobile'
}
